export default __webpack_public_path__ + "static/media/paid.06cc0703.svg";